<!-- 店铺设置/商户等级列表 -->
<template>
  <el-table :data="tableData" style="width: 100%;border: 1px solid #f1f1f1">
    <el-table-column
      type="selection"
      width="60"
      align="center"
    ></el-table-column>
    <el-table-column label="级别" prop="level" align="center"></el-table-column>
    <el-table-column
      label="等级名称"
      prop="name"
      align="center"
    ></el-table-column>
    <el-table-column
      label="可发布商品数"
      prop="goods_num"
      align="center"
    ></el-table-column>
    <el-table-column
      label="可上传图片数"
      prop="pic_num"
      align="center"
    ></el-table-column>
    <el-table-column
      label="可套选模板数"
      prop="tpl_num"
      align="center"
    ></el-table-column>
    <el-table-column
      label="收费标准/年"
      prop="cost"
      align="center"
    ></el-table-column>
    <el-table-column label="操作" align="center">
      <template slot-scope="scope">
        <div class="table_button_line">
          <el-button type="text" @click="edit(scope.row)">编辑</el-button>
          <el-button type="text" @click="del(scope.row.id)">删除</el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    edit(row) {
      console.log(row);
      this.$router.push({
        path: "shopLevelForm",
        query: { editData: row }
      });
    },
    del(id) {
      this.$emit("delItem", id);
    }
  }
};
</script>
